import { Box, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { getTasks } from "./api";
import { getToken } from "../../utils/utils";
import { ispubishedchnages } from "../../components/ActiveTask/api";

function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [taskEnString, setTaskEnString] = useState("");
  const token = getToken();
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await getTasks(token, page, 10,"","");

        const mappedTasks = response.data.data.map((task: any) => ({
          id: task.task_id,
          task: task.task_en,
          startdate: new Date(task.task_start_date).toLocaleDateString(),
          enddate: new Date(task.task_end_date).toLocaleDateString(),
          status: task.task_status === 1 ? "Active" : "Inactive",
          location: task.location,
        }));

        const uniqueTaskEnValues = Array.from(
          new Set(response.data.data.map((task: any) => task.task_en))
        );

        const appendedTaskEn = uniqueTaskEnValues.join(" ");

        setTasks(mappedTasks);
        setTaskEnString(appendedTaskEn);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    fetchTasks();
  }, [token,page]);


  

 

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "task", headerName: "Task", width: 200 },
    { field: "duration", headerName: "Duration", width: 150 },
    // { field: "enddate", headerName: "End Date", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "location", headerName: "Location", width: 150 },
  ];

  return (
    <Box p={3}>
      <Typography sx={{ marginBottom: "34px" }} variant="h4">
        Manage Tasks
      </Typography>

      <Typography sx={{ marginBottom: "16px" }} variant="body1"></Typography>

      <div style={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={tasks}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 },
            },
          }}
          checkboxSelection
        />
      </div>
    </Box>
  );
}

export default Tasks;
